import { normalizeHeaders, requestHeaders } from '@/api';
import { clinicsContractClient } from '@/api/clinics/clinicsContract';
import { QueryKey } from '@/data/query';

export const useClinics = () => {
  const clinicsContract = clinicsContractClient();
  const headers = normalizeHeaders(requestHeaders());
  const queryKey = [QueryKey.listClinics];
  const data = clinicsContract.listClinics.useQuery({
    queryKey,
    queryData: {
      query: undefined,
      headers: { ...headers, authorization: headers['authorization'] }
    }
  });

  return data;
};
